import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfigureModelCtaIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 104,
	height: 105,
	viewBox: "0 0 104 105",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 104,
			height: 104,
			rx: 52,
			fill: "url(#paint0_linear_9627_39093)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_9627_39093)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M36 36.5C36 34.2909 37.7909 32.5 40 32.5H56L68 44.5V68.5C68 70.7091 66.2091 72.5 64 72.5H40C37.7909 72.5 36 70.7091 36 68.5V36.5Z",
					fill: "url(#paint1_linear_9627_39093)"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M56 32.5L68 44.5H60C57.7909 44.5 56 42.7091 56 40.5V32.5Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.95 49.9808C53.8386 49.6911 53.5603 49.5 53.25 49.5C52.9397 49.5 52.6614 49.6911 52.55 49.9808L51.2494 53.3624C51.0241 53.9482 50.9533 54.117 50.8564 54.2532C50.7592 54.3898 50.6398 54.5092 50.5032 54.6064C50.367 54.7033 50.1982 54.7741 49.6124 54.9994L46.2308 56.3C45.9411 56.4114 45.75 56.6897 45.75 57C45.75 57.3103 45.9411 57.5886 46.2308 57.7L49.6124 59.0006C50.1982 59.2259 50.367 59.2967 50.5032 59.3936C50.6398 59.4908 50.7592 59.6102 50.8564 59.7468C50.9533 59.883 51.0241 60.0518 51.2494 60.6376L52.55 64.0192C52.6614 64.3089 52.9397 64.5 53.25 64.5C53.5603 64.5 53.8386 64.3089 53.95 64.0192L55.2506 60.6376C55.4759 60.0518 55.5467 59.883 55.6436 59.7468C55.7408 59.6102 55.8601 59.4908 55.9968 59.3936C56.133 59.2967 56.3018 59.2259 56.8876 59.0006L60.2692 57.7C60.5589 57.5886 60.75 57.3103 60.75 57C60.75 56.6897 60.5589 56.4114 60.2692 56.3L56.8876 54.9994C56.3018 54.7741 56.133 54.7033 55.9968 54.6064C55.8601 54.5092 55.7408 54.3898 55.6436 54.2532C55.5467 54.117 55.4759 53.9482 55.2506 53.3624L53.95 49.9808Z",
					fill: "url(#paint2_linear_9627_39093)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.6391 59.9716C46.5559 59.8053 46.3859 59.7002 46.2 59.7002C46.0141 59.7002 45.8441 59.8053 45.7609 59.9716L45.3758 60.7418C45.2371 61.0191 45.1949 61.0989 45.1435 61.1655C45.092 61.2323 45.0321 61.2922 44.9653 61.3437C44.8987 61.3951 44.8189 61.4373 44.5416 61.576L43.7714 61.9611C43.6051 62.0443 43.5 62.2143 43.5 62.4002C43.5 62.5861 43.6051 62.7561 43.7714 62.8393L44.5416 63.2244C44.8189 63.363 44.8987 63.4053 44.9653 63.4567C45.0321 63.5082 45.092 63.568 45.1435 63.6349C45.1949 63.7015 45.2371 63.7813 45.3758 64.0586L45.7609 64.8288C45.8441 64.9951 46.0141 65.1002 46.2 65.1002C46.3859 65.1002 46.5559 64.9951 46.6391 64.8288L47.0242 64.0586C47.1629 63.7813 47.2051 63.7015 47.2565 63.6349C47.308 63.568 47.3679 63.5082 47.4347 63.4567C47.5013 63.4053 47.5811 63.363 47.8584 63.2244L48.6286 62.8393C48.7949 62.7561 48.9 62.5861 48.9 62.4002C48.9 62.2143 48.7949 62.0443 48.6286 61.9611L47.8584 61.576C47.5811 61.4373 47.5013 61.3951 47.4347 61.3437C47.3679 61.2922 47.308 61.2323 47.2565 61.1655C47.2051 61.0989 47.1629 61.0191 47.0242 60.7418L46.6391 59.9716Z",
					fill: "url(#paint3_linear_9627_39093)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.0158 49.1265C46.9465 48.9879 46.8049 48.9004 46.6499 48.9004C46.4949 48.9004 46.3533 48.9879 46.284 49.1265L45.9631 49.7684C45.8475 49.9995 45.8123 50.066 45.7695 50.1215C45.7266 50.1772 45.6767 50.2271 45.621 50.27C45.5655 50.3128 45.499 50.348 45.2679 50.4636L44.626 50.7845C44.4874 50.8538 44.3999 50.9954 44.3999 51.1504C44.3999 51.3053 44.4874 51.447 44.626 51.5163L45.2679 51.8372C45.499 51.9528 45.5655 51.988 45.621 52.0308C45.6767 52.0737 45.7266 52.1236 45.7695 52.1793C45.8123 52.2348 45.8475 52.3013 45.9631 52.5324L46.284 53.1743C46.3533 53.3128 46.495 53.4004 46.6499 53.4004C46.8049 53.4004 46.9465 53.3128 47.0158 53.1742L47.3367 52.5324C47.4523 52.3013 47.4875 52.2348 47.5303 52.1793C47.5732 52.1236 47.6231 52.0737 47.6788 52.0308C47.7343 51.988 47.8008 51.9528 48.0319 51.8372L48.6738 51.5163C48.8124 51.447 48.8999 51.3053 48.8999 51.1504C48.8999 50.9954 48.8124 50.8538 48.6738 50.7845L48.0319 50.4636C47.8008 50.348 47.7343 50.3128 47.6788 50.27C47.6231 50.2271 47.5732 50.1772 47.5303 50.1215C47.4875 50.066 47.4523 49.9995 47.3367 49.7684L47.0158 49.1265Z",
					fill: "url(#paint4_linear_9627_39093)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_9627_39093",
				x: 29,
				y: 30.5,
				width: 46,
				height: 46,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_9627_39093"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_9627_39093"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_9627_39093",
						result: "effect2_dropShadow_9627_39093"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_9627_39093",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9627_39093",
				x1: 52,
				y1: .5,
				x2: 52,
				y2: 104.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FDFDFD" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F3F5F7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9627_39093",
				x1: 54.5846,
				y1: 32.5,
				x2: 54.5846,
				y2: 74.7222,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#53B1FD" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2E90FA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_9627_39093",
				x1: 60.7501,
				y1: 65.2499,
				x2: 60.7501,
				y2: 48.7499,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D7EAFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_9627_39093",
				x1: 56.1901,
				y1: 63.5335,
				x2: 56.1901,
				y2: 52.7335,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D7EAFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_9627_39093",
				x1: 54.975,
				y1: 52.0948,
				x2: 54.975,
				y2: 43.0948,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EAF4FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})]
			})
		] })
	]
});
export default SvgConfigureModelCtaIcon;
